export default __webpack_public_path__ + "static/media/Soft Skills.71b3352b.svg";